"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEntryFromPartial = void 0;
const isEntryFromPartial = (e) => {
    return typeof e.id === 'string' && typeof e.from === 'number' && typeof e.to === 'number' && typeof e.text === 'string';
};
exports.isEntryFromPartial = isEntryFromPartial;
